import { RefObject, useEffect, useState } from 'react'

export const useStickyScrollDetection = (tableContainerRef: RefObject<HTMLDivElement>) => {
  const [isScrolledToLeft, setIsScrolledToLeft] = useState(true)
  const [isScrolledToRight, setIsScrolledToRight] = useState(false)

  useEffect(() => {
    const element = tableContainerRef.current
    if (!element) {
      return
    }

    const updateScrollState = () => {
      const { scrollLeft, scrollWidth, clientWidth } = element
      const thresholdPx = 12

      setIsScrolledToLeft(scrollLeft <= thresholdPx)
      setIsScrolledToRight(scrollLeft + clientWidth >= scrollWidth - thresholdPx)
    }

    // Update on mount
    updateScrollState()

    // Update on scroll
    element.addEventListener('scroll', updateScrollState)

    // Update on resize
    const resizeObserver = new ResizeObserver(updateScrollState)
    resizeObserver.observe(element)

    return () => {
      element.removeEventListener('scroll', updateScrollState)
      resizeObserver.disconnect()
    }
  }, [])

  return {
    isScrolledToLeft,
    isScrolledToRight,
  }
}
